import React from "react";

const IntroScreen = () => (
  <pre className="iwtcot-banner">
    <code>
      {`░░░░░░░░░░░░░░░░░░░░▒█░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░`}
      <br />
      {`░░░░░░░░░░░░░░░░░░░░▒█░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░`}
      <br />
      {`░░░░░░░░░░░▀█▀░▀█▀░░▒█░░▒█░▄▀▀▄░█▀▀░░▀█▀░█░█░█▀▀░░░░░░░░░░`}
      <br />
      {`░░░░░░░░░░░▒█░░░█░░░▒█▒█▒█░█▄▄█░▀▀▄░░░█░░█▀█░█▀▀░░░░░░░░░░`}
      <br />
      {`▄▀▀▄░░░░░░░▄█▄░░▀░░░░▀▄▀▄▀░▀░░▀░▀▀▀░░░▀░░▀░▀░▀▀▀░░░░░░░░░░`}
      <br />
      {`█░░░▄░░█░█▀▀▄░█▀▀░█▀▀░█▀▄░░▄▀▀▄░█▀░░▀▀█▀▀░▀░░█▀▄▀█░█▀▀░█▀▀`}
      <br />
      {`█░░░█░░█░█▄▄▀░▀▀▄░█▀▀░█░█░░█░∠█░█▀░░░▒█░░░█▀░█░▀░█░█▀▀░▀▀▄`}
      <br />
      {`▀▄▄▀░▀▀▀░▀░▀▀░▀▀▀░▀▀▀░▀▀░░░░▀▀░░▀░░░░▒█░░▀▀▀░▀░░▒▀░▀▀▀░▀▀▀`}
      <br />
      {`░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒█░░░░░░░░░░░░░░░░░░░`}
      <br />
      {`░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒█░░░░░░░░░░░░░░░░░░░`}
      <br />
    </code>
  </pre>
);
export { IntroScreen };
